import { CacheImageDetection, DetectStatus } from "./cache-image-detection";

/**
 * 嗅探图片资源是否存在
 * （先访问缓存，缓存未命中则发送网络请求）
 */
export function loadImage(url) {
  var detectResult = CacheImageDetection.get(url);
  if (detectResult) {
    // 有探测结果
    return detectResult === DetectStatus.Success ? Promise.resolve(true) : Promise.resolve(false);
  }
  // 没有结果就探测，并缓存结果
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      // 缓存结果
      CacheImageDetection.set(url, DetectStatus.Success);
      resolve(true);
    };
    img.onerror = function () {
      // 缓存结果
      CacheImageDetection.set(url, DetectStatus.Fail);
      reject(false);
    };
    img.src = url;
  });
}
//# sourceMappingURL=load-image.js.map